import {
  EDisbursementMethod,
  EEmploymentStatus,
  EPaySchedule,
  publicPaginationSchema,
  publicSortSchema,
  schemes,
  zSchema,
} from "@zeal/common";

export const getPayrollRunEmployeesRequestSchema = zSchema.object({
  disbursement_method: zSchema.nativeEnum(EDisbursementMethod).optional(),
  pay_schedule: zSchema
    .nativeEnum(EPaySchedule)
    .or(zSchema.literal("all"))
    .optional(),
  payroll_run_id: schemes.mongoObjectId(),
  q: zSchema.string().optional(),
  regular_only: zSchema.boolean().optional(),
  ...publicPaginationSchema.shape,
  ...publicSortSchema.shape,
});

export type TGetPayrollRunEmployeesRequest = zSchema.infer<
  typeof getPayrollRunEmployeesRequestSchema
>;

export const getPayrollRunEmployeesResponseSchema = zSchema.object({
  _id: zSchema.string(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
  default_pay_schedule: zSchema.nativeEnum(EPaySchedule),
  employment_status: zSchema.nativeEnum(EEmploymentStatus),
  onboarded: zSchema.boolean(),
});

export type TGetPayrollRunEmployeesResponse = zSchema.infer<
  typeof getPayrollRunEmployeesResponseSchema
>;
